import type { Job } from "../lib/types";

const ICON: Record<string, string> = {
  pending: "○",
  running: "",
  done: "✓",
  failed: "✕",
  skipped: "–",
};

export default function ProgressSteps({ job }: { job: Job | null }) {
  if (!job) return null;

  const failed = job.status === "failed";
  const finished = job.status === "succeeded";

  return (
    <div className="stack">
      <div className="row">
        <strong className="small">
          {failed ? "Failed" : finished ? "Done" : job.current_step || "Starting…"}
        </strong>
        <div className="grow" />
        <span className="small faint">{Math.round((job.progress ?? 0) * 100)}%</span>
      </div>

      <div className="progress-track">
        <i style={{ width: `${Math.round((job.progress ?? 0) * 100)}%` }} />
      </div>

      <div className="steps">
        {(job.steps ?? []).map((step) => (
          <div key={step.key} className={`step is-${step.status}`}>
            <span className="step-icon">
              {step.status === "running" ? <span className="spinner" /> : ICON[step.status] ?? "○"}
            </span>
            <span>{step.label}</span>
            {step.detail && <span className="step-detail">{step.detail}</span>}
          </div>
        ))}
      </div>

      {failed && job.error && (
        <div className="alert alert-error">
          <span>✕</span>
          <div>
            <strong>{job.error.message}</strong>
            {job.error.hint && <div className="alert-hint">{job.error.hint}</div>}
          </div>
        </div>
      )}
    </div>
  );
}
